export const qr = {
  hero: {
    title: {
      pt1: 'Een',
      pt2: 'QR-oplossing',
      pt3: 'op maat gemaakt voor jouw restaurant'
    },
    description: 'Maak een kostenbesparend bestelproces aan tafel mogelijk, ontlast je medewerkers en verbeter je klantervaring vanaf de eerste scan tot en met de betaling.',
    button: 'Ontdek de QR-oplossing'
  },
  paragraphs: {
    paragraph_1: {
      title: 'Vereenvoudig bestellen, maximaliseer klanttevredenheid',
      text: 'Geef je klant de vrijheid om te bestellen wat en wanneer ze willen. Optimaliseer de service, verhoog het gemak en verbeter de klantervaring met elke scan.',
      cta: 'Verken de Bistroo pakketten'
    },
    paragraph_2: {
      title: 'Update je QR-shop gemakkelijk',
      text: 'Alle updates in de Bistroo Manager worden direct gesynchroniseerd met de QR-stickers op je tafels, waardoor het aanpassen van het menu sneller en gemakkelijker is dan ooit.',
      cta: ''
    },
    paragraph_3: {
      title: 'Jouw stijl, jouw stickers',
      text: 'De stickers zijn van hoge kwaliteit en op maat gemaakt in jouw stijl en branding. Ze worden gemaakt van duurzaam en weerbestendig materiaal, waardoor ze geschikt zijn voor zowel binnen- als buitengebruik.',
      cta: 'Verken de Bistroo pakketten'
    },
    paragraph_4: {
      title: 'Makkelijke administratie',
      text: 'Van betalingen tot facturen, alles is volledig geautomatiseerd. Bestellingen worden verwerkt, betalingen kunnen worden gevolgd en facturen worden automatisch gegenereerd, waardoor jouw werklast drastisch verminderd.',
      cta: ''
    }
  },
  key_features: {
    cards: {
      card_1: {
        title: 'Maak upselling een onderdeel van je bedrijf',
        text: 'Maak gebruik van de slimme upsell-opties en maak ze een natuurlijk onderdeel van elke bestelling ter plaatse waardoor de omzet moeiteloos groeit.',
        button: '',
        img_alt: ''
      },
      card_2: {
        title: 'Integraties',
        text: 'Koppel je favoriete POS-systeem of externe tools.',
        button: '',
        img_alt: ''
      },
      card_3: {
        title: 'Los personeelsuitdagingen op',
        text: 'Als er een uitdaging ontstaat, los je deze eenvoudig op met QR-tafelbestellingen.',
        button: '',
        img_alt: ''
      },
      card_4: {
        title: 'Directe betalingen',
        text: 'Geen betaling meer aan de balie, klanten betalen tijdens het bestellen.',
        button: '',
        img_alt: ''
      },
      card_5: {
        title: 'Kortingen en loyaliteit',
        text: 'Moedig klanten aan om de QR-oplossing te gebruiken door gebruik te maken van onze kortings- en loyaliteitsopties.',
        button: '',
        img_alt: ''
      }
    }
  },
  testimonial: {
    text: '“Een fijne samenwerking en een partner die 24/7 voor je klaarstaat.”',
    cta: 'Lees het volledige verhaal',
    name: 'De Wethouder',
    job_title: 'Sushi & Drink Club'
  }
}